import type { TextPlaceholderLine } from '@/shared/types/marketplace.interface';
import { CSSProperties } from 'react';
import './index.less';

const TextPlaceholder = ({
  lines = [],
  style,
}: {
  lines: TextPlaceholderLine[];
  style?: CSSProperties;
}) => {
  return (
    <div className="text-placeholder" style={style}>
      {lines.map((line, index) => (
        <div
          key={`line-${index}`}
          className="text-line-placeholder"
          style={{ width: line.width, height: line.height, background: line.color }}
        />
      ))}
    </div>
  );
};

export default TextPlaceholder;
